import React, { Component } from "react";

import { CloseOutlined } from "@ant-design/icons";

const DURATION = 4;
export default class NotificationMessage extends Component {
  state = {
    show: true,
  };
  show = () => this.setState({ show: true });
  hide = () => this.setState({ show: false });

  componentDidMount = () => {
    setTimeout(() => {
      this.hide();
    }, DURATION * 1000);
  };
  render() {
    return (
      <div className={this.state.show ? "notification" : "hide"}>
        <div className="notification-message">
          You're on your way. Complete more categories to refine your list of
          relevant HSC subjects
        </div>
        <CloseOutlined
          type="close"
          className="notification-close"
          onClick={this.hide}
        />
      </div>
    );
  }
}
